import http from '@/plugins/api'
import {
  startLoading
} from '@/plugins/loading'
import * as types from './types'

export default {
  setNewWorkOrder({
    commit
  }) {
    commit(types.SET_NEW_WORK_ORDER)
  },
  setWorkOrderLocation({
    commit
  }, location) {
    commit(types.SET_WORK_ORDER_LOCATION, location)
  },
  setWorkOrderDevices({
    commit
  }, devices) {
    commit(types.SET_WORK_ORDER_DEVICES, devices)
  },
  setDashboardView({
    commit
  }, view) {
    commit(types.SET_VIEW_DASHBOARD, view)
  },
  setSectionView({
    commit
  }, view) {
    commit(types.SET_VIEW_SECTION, view)
  },
  setStatus({
    commit
  }, status) {
    commit(types.SET_STATUS, status)
  },
  setSearchTerm({
    commit
  }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({
    commit
  }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setRetrospectiveDay({
    commit
  }, days) {
    commit(types.SET_DAYS, days)
  },
  setSelected({
    commit
  }, id) {
    commit(types.SET_SELECTED, id)
  },
  setSortDir({
    commit
  }, sortDir) {
    commit(types.WORKORDER_SORT_DIR, sortDir)
  },
  setOrderBy({
    commit
  }, orderBy) {
    commit(types.WORKORDER_ORDER_BY, orderBy)
  },
  setMobileHandOff({
    commit
  }, data) {
    commit(types.SET_MOBILE_HANDOFF, data)
  },
  setTeamOnlyView({
    commit
  }, data) {
    commit(types.SET_TEAM_ONLY_VIEW, data)
  },
  setCompletedOnlyView({
    commit
  }, data) {
    commit(types.SET_COMPLETED_ONLY_VIEW, data)
  },
  turnOffCompletedOnlyView({
    commit
  }) {
    commit(types.RESET_COMPLETED_ONLY_VIEW)
  },
  async setFilterBy({
    commit,
    dispatch
  }, data) {
    if (data !== undefined && data !== null) {
      if (data.role === 'Tech' || data.role === 'MasterTech' || data.role === 'ReviewTech') {
        await startLoading(dispatch, 'setFilterBy', () =>
          http.post(`ServiceRequest/UpdateTechAvailability/?userId=${data.userId}&status=${data.filter}`))
        try {
          const dispatchUrl = window.config ? window.config.dispatchUrl : ''
          await startLoading(dispatch, 'setFilterBy', () =>
            http.post(`api/posts/UpdateUserStatus/?userID=${data.userId}&statusID=${data.filter}`, {}, {}, dispatchUrl)
          )
        } catch (e) {
          console.error('Error: work-orders store > setFilterBy', e)
        }
      }
      commit(types.WORKORDER_FILTER_BY, data)
    }
  },
  getFilterOptions({
    commit
  }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  clearWorkOrder({
    commit
  }) {
    commit(types.SET_WORK_ORDER, null)
  },
  setHubData({
    commit
  }, data) {
    commit(types.SET_HUB_DATA, data)
  },
  setDeviceStatisticInterval({
    commit
  }, data) {
    commit(types.SET_DEVICE_STATISTIC_INTERVAL, data)
  },
  getStateOptions({
    commit
  }) {
    commit(types.SET_STATE_DEFAULT)
    commit(types.SET_STATE_ASSEMBLY)
    commit(types.SET_STATE_SRS)
    commit(types.SET_STATE_LIGHTS)
    commit(types.SET_STATE_KEY_ENGINE)
    commit(types.SET_STATE_DAMAGE_LEVEL)
    commit(types.SET_STATE_DAMAGE_POSITION)
  },
  async setShopDevice({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'setShopDevice', () =>
      http.post(`ServiceRequest/UpdateWorkOrderShopDevice?workOrderId=${data.workOrderId}&deviceId=${data.device.id}`)
    )
    commit(types.SET_SHOP_DEVICE, data.device)
    return r.data
  },
  setDeviceProtocol({
    commit
  }, data) {
    commit(types.SET_DEVICE_PROTOCOL, data)
  },
  setDeviceInterface({
    commit
  }, data) {
    commit(types.SET_DEVICE_INTERFACE, data)
  },
  setSearchCompleted({
    commit
  }, id) {
    commit(types.SET_SEARCH_COMPLETED, id)
  },
  async getTechStatus({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'getTechStatus', () =>
      http.get(`ServiceRequest/getTechStatus?userId=${data.userId}`)
    )
    if (r.data !== null && r.data !== undefined) {
      let status = {
        filter: r.data.StatusID,
        role: data.role
      }
      commit(types.WORKORDER_FILTER_BY, status)
    }
  },
  async workOrderExists({
    commit,
    dispatch
  }, options) {
    const r = await startLoading(dispatch, 'workOrderExists', () =>
      http.get(`WorkOrder/WorkOrderExists`, {
        params: options
      })
    )
    return r.data
  },
  async findTool({
    commit,
    dispatch
  }, {
    search,
    toolSerialNumber
  }) {
    const r = await startLoading(dispatch, 'findTool', () =>
      http.get(`ServiceRequest/GetDispatchTools?search=${search}`)
    )
    let _tools = []
    for (let i = 0; i < r.data.length; i++) {
      if (r.data[i].StatusID === 1 || r.data[i].SerialNumber === toolSerialNumber) {
        _tools.push({
          id: r.data[i].Id,
          value: r.data[i].FriendlyName,
          status: r.data[i].StatusID,
          serialNumber: r.data[i].SerialNumber
        })
      }
    }
    return _tools
  },
  refreshWorkOrder({
    commit
  }, data) {
    commit(types.REFRESH_WORK_ORDER, data)
  },
  async getWorkOrder({
    commit,
    dispatch
  }, data) {
    if (data !== null) {
      const r = await startLoading(dispatch, 'getWorkOrder', () =>
        http.get(`servicerequest/GetServiceRequest?id=${data.id}&location=${data.location}&status=${data.status}`)
      )
      commit(types.SET_WORK_ORDER, r.data)
    } else {
      commit(types.SET_WORK_ORDER, null)
    }
  },
  async getWorkOrders({
    commit,
    dispatch
  }, searchOptions) {
    // console.log('getWorkOrders', searchOptions)
    const r = await startLoading(dispatch, 'getWorkOrders', () =>
      http.get(`servicerequest/GetServiceRequests`, {
        params: searchOptions
      })
    )
    commit(types.SET_WORK_ORDERS, r.data)
    return r.data
  },
  filterWorkOrders({
    commit
  }, filter) {
    commit(types.FILTER_WORK_ORDERS, filter)
  },
  async getDispatchWorkOrders({
    commit,
    dispatch
  }, ids) {
    const r = await startLoading(dispatch, 'getDispatchWorkOrders', () =>
      http.get(`servicerequest/DispatchWorkOrdersGet?ids=${ids}`)
    )
    commit(types.SET_DISPATCH_WORK_ORDERS, r.data)
    return r.data
  },
  async getWorkOrderHistory({
    commit,
    dispatch
  }, id) {
    const r = await startLoading(dispatch, 'getWorkOrderHistory', () =>
      http.get(`servicerequest/GetServiceRequestHistory?id=${id}`)
    )
    commit(types.SET_WORK_ORDER_HISTORY, r.data)
  },
  async createWorkOrder({
    commit,
    state,
    dispatch
  }, workOrder) {
    const r = await startLoading(dispatch, 'saveWorkOrder', () =>
      http.post(`servicerequest/CreateRequest`, workOrder)
    )
    return r.data
  },
  async saveWorkOrder({
    commit,
    state,
    dispatch
  }, workOrder) {
    await startLoading(dispatch, 'saveWorkOrder', () =>
      http.post(`c/ServiceRequest/UpsertWorkOrder`, {
        id: workOrder.id
      })
    )
  },
  async saveWorkOrderScanType({
    commit,
    dispatch
  }, scanType) {
    const r = await startLoading(dispatch, 'saveWorkOrderScanType', () =>
      http.post(`WorkOrder/UpdateScanType?workOrderId=${scanType.workOrderId}&scanTypeId=${scanType.scanTypeId}`))
    if (r.data) {
      commit(types.SET_WORK_ORDER_SCAN_TYPE, scanType)
    }
    return r.data
  },
  async saveWorkOrderStatus({
    commit,
    dispatch
  }, status) {
    const r = await startLoading(dispatch, 'saveWorkOrderStatus', () =>
      http.post('serviceRequest/UpdateWorkOrderStatus', status))
    commit(types.SET_WORK_ORDER_STATUS, r.data)
    if (status.statusId === 150) {
      // Only if Voided do we call to update Dispatch
      await startLoading(dispatch, 'saveWorkOrderStatus', () =>
        http.post(`ServiceRequest/DispatchWorkOrdersInsert`, status))
    }
    return r.data
  },
  async updateScheduleDateTime({
    commit,
    dispatch
  }, schedule) {
    const r = await startLoading(dispatch, 'updateScheduleDateTime', () =>
      http.post('serviceRequest/UpdateScheduleDateTime', schedule))
    commit(types.SET_WORK_ORDER_SCHEDULE, r.data)
    return r.data
  },
  async saveDispatchStatus({
    commit,
    dispatch
  }, status) {
    if (status.StatusId === 41) {
      status.StatusId = 144
    } else if (status.StatusId === 33) {
      status.StatusId = 146
    } else if (status.StatusId === 142) {
      status.StatusId = 143
    }
    // update the dispatch work order status
    const r = await startLoading(dispatch, 'saveDispatchStatus', () =>
      http.post('serviceRequest/UpdateDispatchWorkOrderStatus', status))
    // status
    console.log('Work Order Status returned', {
      results: r,
      status: status
    })
    let results = null
    if (r === undefined || r === null) {
      results = {
        Status: {
          Id: status.StatusId,
          Text: status.StatusName
        }
      }
    } else {
      if (r.data === undefined || r.data === null) {
        results = {
          Status: {
            Id: status.StatusId,
            Text: status.StatusName
          }
        }
      } else if (r.data === '') {
        results = {
          Status: {
            Id: status.StatusId,
            Text: status.StatusName
          }
        }
      } else {
        results = r.data
      }
    }
    commit(types.SET_WORK_ORDER_STATUS, results)
    // need to do the same thing for old Dispatch
    try {
      const dispatchUrl = window.config ? window.config.dispatchUrl : ''
      await startLoading(dispatch, 'saveDispatchStatus', () =>
        http.post(`api/posts/UpdateWorkOrder/`, {
          workOrder: status.WorkOrderId,
          user: status.UserName,
          userID: status.UserId,
          tool: status.ToolName,
          toolID: status.ToolId,
          status: status.StatusName,
          statusID: status.StatusId
        }, {}, dispatchUrl)
      )
    } catch (e) {
      console.error('Error: work-orders store > saveDispatchStatus', e)
    }
    return r.data
  },
  async getScanReport({
    commit,
    dispatch
  }, workorderid) {
    const r = await startLoading(dispatch, 'getScanReport', () =>
      http.get('Report/CreatePdf', {
        params: {
          workorderid
        }
      })
    )
    return r.data
  },
  async sendScanReport({
    commit,
    dispatch
  }, workorderid) {
    const r = await startLoading(dispatch, 'sendScanReport', () =>
      http.post(`Email/ScanReportSaved?workOrderId=${workorderid}`)
    )
    return r.data
  },
  async sendMobileHandoffRequest({
    commit,
    dispatch
  }, workorderid) {
    const r = await startLoading(dispatch, 'sendMobileHandoffRequest', () =>
      http.get('Email/SendMobileHandoffRequest', {
        params: {
          workorderid
        }
      })
    )
    return r.data
  },
  async getRepairLines({
    commit,
    dispatch
  }, vin) {
    const r = await startLoading(dispatch, 'getRepairLines', () =>
      http.post('bms/GetLinesTotals', {
        Xml: '',
        Vin: vin,
        WorkOrder: ''
      })
    )
    commit(types.GET_REPAIR_LINES, r.data)
  },
  async saveNotes({
    commit,
    dispatch
  }, note) {
    const r = await startLoading(dispatch, 'saveNotes', () =>
      http.post('WorkOrder/CreateNote', {
        id: JSON.stringify(note)
      }))
    commit(types.SET_WORK_ORDER_NOTES, note)
    return r.data
  },
  async createScanReport({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'saveScanReport', () =>
      http.post('Report/CreateScanReport', data))
    return r.data
  },
  async updateScanReport({
    commit,
    dispatch
  }, data) {
    // console.log('actions > updateScanReport', data)
    const r = await startLoading(dispatch, 'saveScanReport', () =>
      http.post('Report/UpdateScanReport', data))
    return r.data
  },
  async updateMobileHandoff({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'updateMobileHandoff', () =>
      http.post('Report/updateMobileHandoff', data))
    return r.data
  },
  async updateTechStatus({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'updateTechStatus', () =>
      http.post(`DispatchOrch/UpdateTechStatus?workOrderId=${data.workOrderId}&status=${data.status}&userId=${data.userId}`))
    return r.data
  },
  async assignTechToWorkOrder({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'assignTechToWorkOrder', () =>
      http.post(`ServiceRequest/DispatchWorkOrdersInsert`, data))
    commit(types.SET_WORKORDER_ASSIGNMENT, data)
    commit(types.WORKORDER_FILTER_BY, {
      filter: 0,
      role: 'Tech',
      userId: data.userId
    })
    try {
      const signalrUrl = window.config ? window.config.signalrUrl : ''
      await startLoading(dispatch, 'assignTechToWorkOrder', () =>
        http.post(`broadcast/SendMessage`, {
          userId: data.userId,
          message: 'Assignment'
        }, {}, signalrUrl))
    } catch (e) {
      console.error('Error: work-orders store > assignTechToWorkOrder', e)
    }
    return r.data
  },
  async getAvailableTechsForWorkOrders({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'getAvailableTechsForWorkOrders', () =>
      http.get(`UserQuery/GetAvailableTechsForWorkOrders`))
    let _data = []
    for (let item of r.data) {
      if (item.statusID === 1) {
        _data.push(JSON.parse(JSON.stringify(item)))
      }
    }
    return _data
  },
  setScanReportFollowUp({
    commit
  }, value) {
    commit(types.UPDATE_SCAN_REPORT_FOLLOW_UP, value)
  },
  setScanReportDetails({
    commit
  }, details) {
    commit(types.UPDATE_SCAN_REPORT, details)
  },
  async getWorkOrderHelpRequests({
    commit,
    dispatch
  }, id) {
    const r = await startLoading(dispatch, 'getWorkOrderHelpRequests', () =>
      http.get(`WorkOrderHelpRequest/GetHelpRequests?id=${id}`)
    )
    commit(types.SET_TOOLBARMENU_REQUEST_HELP, r.data)
  },
  async getWorkOrderHelpRequestsforTL({
    commit,
    dispatch
  }, id) {
    const r = await startLoading(dispatch, 'getWorkOrderHelpRequestsforTL', () =>
      http.get(`WorkOrderHelpRequest/GetHelpRequests?id=${id}`)
    )
    commit(types.SET_TOOLBARMENU_REQUEST_HELP, r.data)
  },
  async setWorkOrderHelpRequest({
    dispatch
  }, helprequest) {
    await startLoading(dispatch, 'updateScheduleDateTime', () =>
      http.post('WorkOrderHelpRequest/UpsertHelpRequests', helprequest))
  },
  async getAllWorkOrderHelpRequests({
    commit,
    dispatch
  }, id) {
    const r = await startLoading(dispatch, 'getWorkOrderHelpRequests', () =>
      http.get(`WorkOrderHelpRequest/GetAllHelpRequestsforLeads?id=${id}`)
    )
    commit(types.SET_TOOLBARMENU_REQUEST_HELP, r.data)
  },
  async decodeVin({
    commit,
    dispatch
  }, vin) {
    const r = await startLoading(dispatch, 'decodeVin', () =>
      http.get(`Decoder/DecodeVinAsTech/?vin=${vin}`))
    return r.data
  },
  async getVehicleYears({
    commit,
    dispatch
  }) {
    const r = await startLoading(dispatch, 'getVehicleYears', () =>
      http.get(`ServiceRequest/VehicleYears`))
    return r.data
  },
  async getVehicleMakes({
    commit,
    dispatch
  }, year) {
    const r = await startLoading(dispatch, 'getVehicleMakes', () =>
      http.get(`ServiceRequest/VehicleMakes/?year=${year}`))
    return r.data
  },
  async getVehicleModels({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'getVehicleModels', () =>
      http.get(`ServiceRequest/VehicleModels/?year=${data.year}&make=${data.make}`))
    return r.data
  },
  async getVehicleSubModels({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'getVehicleSubModels', () =>
      http.get(`ServiceRequest/VehicleSubmodels/?year=${data.year}&make=${data.make}&model=${data.model}`))
    return r.data
  },
  async getVehicleEngines({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'getVehicleEngines', () =>
      http.get(`ServiceRequest/VehicleEngines/?year=${data.year}&make=${data.make}&model=${data.model}&submodel=${data.submodel}`))
    return r.data
  },
  async getVehicleTransmissions({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'getVehicleTransmissions', () =>
      http.get(`ServiceRequest/VehicleTransmissions/?year=${data.year}&make=${data.make}&model=${data.model}`))
    return r.data
  },
  async getVehicleDriveTypes({
    commit,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'getVehicleDriveTypes', () =>
      http.get(`ServiceRequest/VehicleDriveTypes/?year=${data.year}&make=${data.make}&model=${data.model}`))
    return r.data
  },
  async saveVehicleInfo({
    commit,
    dispatch
  }, data) {
    await startLoading(dispatch, 'saveVehicleInfo', () =>
      http.post(`ServiceRequest/UpdateWorkOrderVehicle`, data))
    commit(types.SET_WORKORDER_VEHICLE, data)
  },
  async updateWorkOrder({
    commit,
    dispatch
  }, data) {
    await startLoading(dispatch, 'updateWorkOrder', () =>
      http.post(`ServiceRequest/UpdateRequest`, data))
  },
  async sendHelpRequestNotification({
    dispatch
  }, data) {
    try {
      console.log('Help Data', data)
      const signalrUrl = window.config ? window.config.signalrUrl : ''
      await startLoading(dispatch, 'sendHelpRequestNotification', () =>
        http.post(`broadcast/SendMessage`, {
          userId: data.userId,
          message: data.message,
          data: JSON.stringify(data.data)
        }, {}, signalrUrl))
    } catch (e) {
      console.error('Error: work-orders store > sendHelpRequestNotification', e)
    }
  },
  setScanReportProgrammingPerformed({
    commit
  }, value) {
    let x = 0
    if (value) {
      x = 1
    }
    commit(types.UPDATE_SCAN_REPORT_PERFORMED_PROGRAMMING, x)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/work-orders/actions.js